var w = window,
d = document,
e = d.documentElement,
g = d.getElementsByTagName('body')[0],
widthviewport = w.innerWidth || e.clientWidth || g.clientWidth,
heightviewport = w.innerHeight || e.clientHeight || g.clientHeight;

$(document).ready(function() {

	$('.anchorscroll').anchorScroll({
		scrollSpeed: 1500, 
		offsetTop: 40,
	});

	$('.m--header .anchorscroll').on('click', function(){
		$('.menu--burger').removeClass('active');
		$('body').removeClass('sidebar-active');
	});

	$('.banner-slider').slick({
		speed:1000,
		pauseOnHover:false,
		pauseOnFocus:false
	});

	$('.popup-homevideo').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		iframe: {
			markup: '<div class="mfp-iframe-scaler popup__video">'+
			'<div class="mfp-close">CLOSE</div>'+
			'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
			'</div>'
		},
		fixedContentPos: false,
		disableOn: 0,
		callbacks: {
			open: function() {
				document.body.style.overflow = "hidden";
			},
			close: function() {
				document.body.style.overflow = "visible";
			}
		}
	});

	$('.slick-sectionbanner').slick({
		autoplay:true,
		autoplaySpeed:5000,
		speed:1500,
		arrows: false,
		fade: true,
		dots:true,
		pauseOnHover:false,
		pauseOnFocus:false,
		responsive: [{
			breakpoint: 768,
			settings: {
				fade: false,
				arrows: true,
				dots:false
			}
	    }]
	});

	$('#township-gallery-desktop .gallery-item').magnificPopup({
		type: 'image',
		mainClass: 'mfp-fade',
		gallery: {
			enabled: true,
			preload: [0,2], // read about this option in next Lazy-loading section

			navigateByImgClick: true,

			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

			tPrev: 'Previous (Left arrow key)', // title for left button
			tNext: 'Next (Right arrow key)', // title for right button
			tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
		},
		image: {
			titleSrc: function(item) {
				return '<h5 class="playfair bolditalic">' + item.el.attr('title') + '</h5>';
			}
		},
		callbacks: {
		  open: function() {
		    $('#body').addClass('gallery--body')
		  },
		  close: function() {
		  	$('#body').removeClass('gallery--body')
		  }
		}
	});

	$('#township-gallery-mobile .gallery-item').magnificPopup({
		type: 'image',
		mainClass: 'mfp-fade',
		gallery: {
			enabled: true,
			preload: [0,2], // read about this option in next Lazy-loading section

			navigateByImgClick: true,

			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

			tPrev: 'Previous (Left arrow key)', // title for left button
			tNext: 'Next (Right arrow key)', // title for right button
			tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
		},
		image: {
			titleSrc: function(item) {
				return '<h5 class="playfair bolditalic">' + item.el.attr('title') + '</h5>';
			}
		},
		callbacks: {
		  open: function() {
		    $('#body').addClass('gallery--body')
		  },
		  close: function() {
		  	$('#body').removeClass('gallery--body')
		  }
		}
	});

	// // show unit spec
 //    $(".show-unitspec").click(function(e){
 //    	e.preventDefault();
 //    	var getut = $(this).attr("href");
 //    	if($(getut).hasClass("active")){
 //    		$(getut).removeClass("active");
 //    		$(this).removeClass('collapse');
 //    	}else{
 //    		$(getut).addClass("active");
 //    		$(this).addClass('collapse');
 //    	}
 //    });

 //    // show more unit types
	// $(".btn--moreut").on("click", function(e){
	// 	e.preventDefault();
	//     $(".unit__list").addClass("active");
	//     $(this).css("cssText","display:none !important;");
 //    });

});



// GOOGLE MAP CUSTOMs
function initMap() {
	var latlng = new google.maps.LatLng(-6.3144561,106.73230112);
	var myOptions =
    {
        zoom: 16,
        center: latlng,
        mapTypeId: 'roadmap',
        scrollwheel: false
    };
    var myOptions2 =
    {
        zoom: 16,
        center: latlng,
        mapTypeId: 'roadmap',
        scrollwheel: false,
        streetViewControl: false,
        panControl: false
    };

    var mapdialog = new google.maps.Map(document.getElementById("map-withdialog"), myOptions);
    var mapcontact = new google.maps.Map(document.getElementById("map-contact"), myOptions2);

    var iconBase = '/images/township/marker_icon/';

    var mapdialogicons = {
    	cluster: {
    		icon: iconBase + 'logo-paradiseresortblue.png'
    	},
    	accommodation: {
    		icon: iconBase + 'marker-hotel.png'
    	},
    	station: {
    		icon: iconBase + 'marker-station.png'
    	},
    	shop: {
    		icon: iconBase + 'marker-shop.png'
    	},
    	school: {
    		icon: iconBase + 'School.png'
    	},
    	hotel: {
    		icon: iconBase + 'marker-hotel.png'
    	},
    	hospital: {
    		icon: iconBase + 'marker-hospital.png'
    	},
    	highway: {
    		icon: iconBase + 'marker-highway.png'
    	},
    	mall: {
    		icon: iconBase + 'marker-shop.png'
    	}    ,
    	university: {
    		icon: iconBase + 'University.png'
    	},
    	supermarket: {
    		icon: iconBase + 'Supermarket.png'
    	},
    	traditional_market: {
    		icon: iconBase + 'Traditional_Market.png'
    	}
    };
    var mapcontacticons = {
      cluster: {
        icon: iconBase + 'logo-paradiseresort.png'
      }
    };


    var mapdialogfeatures = [      
      {
        position: new google.maps.LatLng(-6.31022258, 106.72364831),
        type: 'accommodation'
      }, {
        position: new google.maps.LatLng(-6.31414685, 106.72442079),
        type: 'accommodation'
      }, {
        position: new google.maps.LatLng(-6.31510659, 106.72751069),
        type: 'school'
      }, {
        position: new google.maps.LatLng(-6.31634358, 106.73570752),
        type: 'highway'
      }, {
        position: new google.maps.LatLng(-6.31621562, 106.73639417),
        type: 'station'
      }, {
        position: new google.maps.LatLng(-6.31156622, 106.7274034),
        type: 'station'
      }, {
        position: new google.maps.LatLng(-6.31359234, 106.7335403),
        type: 'hospital'
      }, {
        position: new google.maps.LatLng(-6.31702606, 106.73594356),
        type: 'shop'
      }, {
        position: new google.maps.LatLng(-6.31393358, 106.72753215),
        type: 'shop'
      }, {
       	position: new google.maps.LatLng(-6.31629026, 106.73202217),
        type: 'cluster'
      }
    ]
    var mapcontactfeatures = [      
	    {
	    	position: new google.maps.LatLng(-6.31629026, 106.73202217),
	    	type: 'cluster'
	    }
    ]

    var contentString = '<div class="box__info">'+
				'<h5 class="margin0 gotham book">RS Buah Hati Ciputat</h5>'+
				'<small class="gotham bold s10">RUMAH SAKIT</small>'+
				'<center><img src="/images/cluster/voyage/img-infomarker1.jpg" alt=""></center>'+
				'<div class="row">'+
					'<div class="span10 box__info-desc">Most people are unaware that the use of Botox for the prevention of migraine headaches came about purely by accident.</div>'+
					'<div class="span2 gotham bold marginr0 box__info-distance">0.5 <br><span class="gotham book">KM</span></div>'+
				'</div>'+
			'</div>';

    var infowindow = new google.maps.InfoWindow({
      	content: contentString
    });

    // Create markers.
    mapdialogfeatures.forEach(function(feature) {
    	var mapdialogmarker = new google.maps.Marker({
    		position: feature.position,
    		icon: mapdialogicons[feature.type].icon,
    		map: mapdialog
    	});

    	if(feature.type != 'cluster'){
    		mapdialogmarker.addListener('click', function() {
    			infowindow.open(mapdialog, mapdialogmarker);
    		});
    	}
    });
    mapcontactfeatures.forEach(function(feature) {
      var mapcontactmarker = new google.maps.Marker({
        position: feature.position,
        icon: mapcontacticons[feature.type].icon,
        map: mapcontact
      });
    });
    var marker = new google.maps.Marker({
    	position: {lat: -6.31413619, lng: 106.73230112},
    	map: mapcontact
    });


    var mapdialogstyledMapType = new google.maps.StyledMapType(
	[
	 {
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#f5f5f5"
	      }
	    ]
	  },
	  {
	    "elementType": "labels.icon",
	    "stylers": [
	      {
	        "visibility": "off"
	      }
	    ]
	  },
	  {
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#616161"
	      }
	    ]
	  },
	  {
	    "elementType": "labels.text.stroke",
	    "stylers": [
	      {
	        "color": "#f5f5f5"
	      }
	    ]
	  },
	  {
	    "featureType": "administrative.land_parcel",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#bdbdbd"
	      }
	    ]
	  },
	  {
	    "featureType": "poi",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#eeeeee"
	      }
	    ]
	  },
	  {
	    "featureType": "poi",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#757575"
	      }
	    ]
	  },
	  {
	    "featureType": "poi.park",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#e5e5e5"
	      }
	    ]
	  },
	  {
	    "featureType": "poi.park",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#9e9e9e"
	      }
	    ]
	  },
	  {
	    "featureType": "road",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#ffffff"
	      }
	    ]
	  },
	  {
	    "featureType": "road.arterial",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#757575"
	      }
	    ]
	  },
	  {
	    "featureType": "road.highway",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#dadada"
	      }
	    ]
	  },
	  {
	    "featureType": "road.highway",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#616161"
	      }
	    ]
	  },
	  {
	    "featureType": "road.local",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#9e9e9e"
	      }
	    ]
	  },
	  {
	    "featureType": "transit.line",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#e5e5e5"
	      }
	    ]
	  },
	  {
	    "featureType": "transit.station",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#eeeeee"
	      }
	    ]
	  },
	  {
	    "featureType": "water",
	    "elementType": "geometry",
	    "stylers": [
	      {
	        "color": "#c9c9c9"
	      }
	    ]
	  },
	  {
	    "featureType": "water",
	    "elementType": "labels.text.fill",
	    "stylers": [
	      {
	        "color": "#9e9e9e"
	      }
	    ]
	  }
	],{name: 'Styled Map'});

    //Associate the styled map with the MapTypeId and set it to display.
	mapdialog.mapTypes.set('styled_map', mapdialogstyledMapType);
	mapdialog.setMapTypeId('styled_map');

	mapcontact.mapTypes.set('styled_map', mapdialogstyledMapType);
	mapcontact.setMapTypeId('styled_map');
}

